import React, {useEffect, useState} from 'react';
import { Layout, Row, Col, Pagination } from 'antd';
import { Descriptions, Space, Spin } from 'antd';
import axios from "axios";
import AxiosRequest, {AxiosRequestWithImba, AxiosRequestWithImbaNew} from "../../helpers/AxiosRequest";
import StatTable from "../../components/statisticsTable/StatTable";
import {Link} from "react-router-dom";
import DeleteMsg from "../../components/msgsTable/deleteMsg";
import UsersBan from "../../components/usersTable/usersBan";
import StatisticsFilter from "../../components/statisticsTable/statisticsFilter"; 

const { Content } = Layout;

const SingleStatisticPage = (props) => {

    const [user, setUser] = useState({});
    const [userData, setUserData] = useState({});
    const [msgs, setMsgs] = useState(null);
    const [total, setTotal] = useState(0);
    const [per, setPer] = useState(10);
    const [filters, setFilters] = useState({imba_id: props.match.params.imba_id, per_page: 10, page: 1});
    const [loading, setLoading] = useState(false);
    const columns = [
        
        {
            title: 'Question time',
            dataIndex: 'quest',
            key: 'quest',
            render: text => <p>{text}</p>
        },
        {
            title: 'Response time',
            dataIndex: 'answer',
            key: 'answer',
            render: text => <p>{text}</p>
        },
        {
            title: 'Question',
            dataIndex: 'message_quest',
            key: 'message_quest',
            render: text => <p>{text}</p>
        },
        {
            title: 'Answer',
            dataIndex: 'support_answer',
            key: 'support_answer',
            render: text => <p>{text}</p>
        }
        
    ];

    function pad(s) { return (s < 10) ? '0' + s : s; }

    function onChangePage(page, size) {
        setLoading(true);
        setFilters({
            ...filters,  //take existing key-value pairs and use them in our new state,
            page: page   //define new key-value pair with new uuid and [].
        })
    }
    function onChangeSize(current, size) {
        setLoading(true);
        setFilters({
            ...filters.per_page = size,  //take existing key-value pairs and use them in our new state,
            page: 1,
        })
    }


    useEffect(() => {
        (async () => {
            console.log('props.match.params',props.match.params)
            
            setTimeout(()=>{
                if(document.querySelector(".ant-spin-dot.ant-spin-dot-spin")!=null) {
                    //window.location.reload()
                }
            },15000)
            AxiosRequestWithImba("get_statistic", {
                id: props.match.params.id,
                imba_id: props.match.params.imba_id,
                filters: filters
            },props.match.params.imba_id )
                .then((data) => {
                    setUser(data.avg)
                    setUserData(data)
                    setMsgs(data.avg)
                    setTotal(data.total)
                    setLoading(false);
                })
                .catch((error) =>{
                    setLoading(false);
                    console.log('error1',error)
                    
                });
        })();
    }, [filters]);

    useEffect(() => {
        if (user.id)
        {
            let params = {
                id: user.id,
                imba_id: props.match.params.imba_id
            }
            AxiosRequestWithImba('get_statistic', params, props.match.params.imba_id)
                .then((response) => {
                    console.log('response',response)
                    //setMsgs(response.data)
                    setUser(response.avg)
                })
        }
    }, [user])
    const UserData = () => (
            <Descriptions title="Detailed information" layout="vertical">
                <Descriptions.Item label="Login">{userData.login}</Descriptions.Item>
                <Descriptions.Item label="Role">{userData.status}</Descriptions.Item>
                <Descriptions.Item label="Rating">{userData.rating}</Descriptions.Item>
                <Descriptions.Item label="Max. time">{userData.max}</Descriptions.Item>
                <Descriptions.Item label="Min. time">{userData.min}</Descriptions.Item>
            </Descriptions>
    )
    const onChangeFilter = (values) => {
        setLoading(true);
        values.imba_id = props.match.params.imba_id;
        values.per_page = per;
        values.page = 1;
        setFilters(values)

    }
    return(
        <div>
            <StatisticsFilter onChange={onChangeFilter}/>
            <Space size="middle" className={'absolute'}>
                <Spin size="large" spinning={loading} className={'absolute'} />
            </Space>
            <Content style={{ padding: '50px 150px' }}>
                <div className="site-layout-content">
                    <UserData />
                </div>
            </Content>
            <div>
            <StatTable columns={columns} dataSource={msgs}  />
            <Pagination
                className={'table-pagination'}
                showSizeChanger
                onShowSizeChange={onChangeSize}
                defaultCurrent={1}
                PageSize={per}
                total={total}
                onChange={onChangePage}
            />
            </div>
        </div>
    )
}

export default SingleStatisticPage;